import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'angular-bootstrap-md';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Address } from 'src/app/models/Address';
import { Clothes } from 'src/app/models/Clothes';
import { DataOrder } from 'src/app/models/DataOrder';
import { GeneralStaff } from 'src/app/models/GeneralStaff';
import { InfoObservation } from 'src/app/models/InfoObservation';
import { Job } from 'src/app/models/Job';
import { Order } from 'src/app/models/Order';
import { PinGroup } from 'src/app/models/PinGroup';
import { Ribbon } from 'src/app/models/Ribbon';
import { Weapon } from 'src/app/models/Weapon';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BlockService } from 'src/app/services/block.service';
import { ObservationService } from 'src/app/services/observation.service';
import { OrderService } from 'src/app/services/order.service';
import { PinService } from 'src/app/services/pin.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {

  public nid: string;
  public firstName: string;
  public lastName: string;
  public phone: string;
  public email: string;
  public addresses: Address[];
  public savedOrder: Order;
  public originalOrder: Order;
  public version: string = 'HMAC_SHA256_V1';
  public parameters: string;
  public signature: string;
  public order: Order = new Order();
  public totalPrice: number;
  public selectAddress: number;
  public separatedOrders: Order[];
  public mapDetail = new Map();
  public disabled: any;
  public imagesUrl: string = CONSTANTES.imagesUrl;
  @ViewChild('confirmModal') confirmModal: ModalDirective;
  @ViewChild('addressModal') addressModal: ModalDirective;
  @ViewChild('printModal') printModal: ModalDirective;
  @ViewChild('observationModal') observationModal: ModalDirective;
  @ViewChild('measuresModal') measuresModal: ModalDirective;
  @ViewChild('pinModal') pinModal: ModalDirective;
  public description : string;
  public startDate : Date;
  public endDate : Date;
  public bloqueado: boolean = false;

  public infoObservations: InfoObservation = new InfoObservation();
  public myCintura: string;
  public myTorax: string;
  public myAltura: string;
  public weaponData :String;
  public jobData :String;
  public ribbonData :String;
  public generalStaffData :String;
  public observationData :String;
  public indexClothes: number;

  public myPinsObservation: String;
  pinesGroup: PinGroup[] = [];
  imagesUrlPins = CONSTANTES.pasadoresUrl;
  public activeSlideIndex: any = 0;
  public changes: boolean = false;

  constructor(private spinner: NgxSpinnerService, private router: Router, private orderService: OrderService,
    private toastr: ToastrService, private authService: AuthenticationService, private blockService: BlockService , private observationService: ObservationService,
    private pinService: PinService) { }

  ngOnInit() {
    this.spinner.show();
    try{
      jQuery.getScript(CONSTANTES.menu);
      this.nid = localStorage.getItem("nid");
      this.firstName = localStorage.getItem("firstName");
      this.lastName = localStorage.getItem("lastName");
      this.phone = localStorage.getItem("phone");
      this.email = localStorage.getItem("email");
      this.addresses = JSON.parse(localStorage.getItem("addresses"));
    } catch(Error){
      this.router.navigate(['login']);
    }
        this.getPinGroup();
		    this.checkBloqueado();
  }

  // Función para obtener los pedidos guardados del usuario
  getOrder(){
    let dataOrder: DataOrder = {
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: this.nid,
      orders: null,
      status: null,
      receiptOrders: null,
      dataBank: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: localStorage.getItem("role"),
      noc: null
    }
    this.totalPrice = 0;
    this.orderService.getOrdersToConfirm(dataOrder).subscribe(
      data => {
        if (getToken(data)){
          if (data.orders !== null && data.orders.length > 0) {
            this.savedOrder = data.orders[0];
            this.savedOrder.orderDetails.forEach(orderDetail => {
              // Ordenamos los precios por fecha
              orderDetail.clothes.prices.sort((a, b) => {
                if (a.priceDate < b.priceDate) {
                  return -1;
                } else if (a.priceDate > b.priceDate) {
                  return 1;
                } else {
                  return 0;
                }
              });

              // Dejamos solo una imagen para mostrar
              for (let i: number = orderDetail.clothes.pictures.length -1; i >= 0; i--){
                if (orderDetail.clothes.pictures[i].deleted === true){
                  orderDetail.clothes.pictures.splice(i,1);
                } else if (orderDetail.clothes.pictures[i].fileName === null){
                  orderDetail.clothes.pictures[i].fileName = "default.png";
                }
              }
            });
            this.originalOrder = this.savedOrder;
            localStorage.setItem("articulos", this.savedOrder.orderDetails.length.toString());
            this.orderService.sendUpdate(this.savedOrder.orderDetails.length.toString());
            this.orderService.changeTime(this.savedOrder.confirmDate.toString());
            this.orderService.changeStatus(this.savedOrder.status);
          } else {
            this.toastr.info("NO DISPONE DE PEDIDOS GUARDADOS", "NO HAY PEDIDOS");
            this.router.navigate(['home']);
          }
          this.spinner.hide();
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          this.spinner.hide();
        }
      }, error => {
        this.toastr.error(error);
        this.logOut();
      }
    );
  }

  // Función para eliminar el total de un artículo del pedido
  eliminarItem(orderNumberBank: string, clothName: string, ribbonName: Ribbon, jobName: Job, weaponName: Weapon, generalStaffName: GeneralStaff){
    this.spinner.show();
    // Recorremos los pedidos para localizar el artículo a eliminar

    if(orderNumberBank === this.savedOrder.orderNumberBank){
      for (let i = 0; i < this.savedOrder.orderDetails.length; i++){
        if (this.savedOrder.orderDetails[i].clothes.name === clothName){
          if((this.savedOrder.orderDetails[i].ribbon === null || this.savedOrder.orderDetails[i].ribbon.description === ribbonName.description)
            && (this.savedOrder.orderDetails[i].job === null || this.savedOrder.orderDetails[i].job.description === jobName.description)
            && (this.savedOrder.orderDetails[i].weapon === null || this.savedOrder.orderDetails[i].weapon.description === weaponName.description)
            && (this.savedOrder.orderDetails[i].generalStaff === null || this.savedOrder.orderDetails[i].generalStaff.description === generalStaffName.description)){
              // Restamos el precio del total del artículo al pedido
              this.savedOrder.price -= this.savedOrder.orderDetails[i].clothes.prices[this.savedOrder.orderDetails[i].clothes.prices.length - 1].price * this.savedOrder.orderDetails[i].amount;
              // Eliminamos el artículo del pedido
              this.savedOrder.orderDetails.splice(i, 1);
          }
          
        }
      }
    }
    // Añadimos el pedido modificado a un DataOrder para modificarlo en BBDD
    let dataOrder: DataOrder = {
      dataBank: null,
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: localStorage.getItem("nid"),
      orders: [],
      receiptOrders: null,
      status: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null
    };
    dataOrder.orders.push(this.savedOrder);
    if (this.savedOrder.orderDetails.length > 0){
      this.modifyOrder(dataOrder);
    } else {
      this.cancelarPedido(dataOrder);
    }
  }

  // Aumenta 1 la cantidad de un artículo
  aumentarCant(orderNumberBank: string, orderDetail: any){
    // Buscamos el pedido al que hay que sumarle un artículo
    let observa: Boolean = false;
    if (this.savedOrder.orderNumberBank === orderNumberBank){
      // Buscamos el detalle del pedido correspondiente con el artículo
      return this.savedOrder.orderDetails.forEach(detail => {
        if (orderDetail.clothes.observations !== undefined && orderDetail.clothes.observations.length !== 0){
          orderDetail.clothes.observations.forEach(observations => {
            if(observations.type==="Comentario"){
              observa = true;
            }
          });
        }else{
          observa = false;
        }
        if ((detail.clothes.code === orderDetail.clothes.code && detail.size === orderDetail.size 
          && (detail.clothes.observations===undefined || detail.clothes.observations.length===0 || !observa))
          
          || (detail.clothes.code === orderDetail.clothes.code && detail.size === orderDetail.size &&
            orderDetail.clothes.observations.length>0 && observa && orderDetail.job.description===detail.job.description &&
            orderDetail.ribbon.description===detail.ribbon.description && orderDetail.weapon.description===detail.weapon.description
            && orderDetail.generalStaff.description===detail.generalStaff.description)){

          let clothPrice = detail.clothes.prices[detail.clothes.prices.length - 1].price;
          return detail.clothes.nocSizes.forEach(nocSize => {
            // Comprobamos que haya stock
            if ((nocSize.size === detail.size && (detail.clothes.observations===undefined || detail.clothes.observations.length===0 || !observa))
            || (nocSize.size === detail.size && detail.clothes.observations.length>0 && observa && nocSize.generalStaff.description===detail.generalStaff.description &&
              nocSize.job.description== detail.job.description && nocSize.ribbon.description===detail.ribbon.description && nocSize.weapon.description===detail.weapon.description)){
              if (detail.amount < (nocSize.stock - nocSize.threshold)){
                detail.amount += 1;
                this.changes = true;
                return this.savedOrder.price += clothPrice;
              } else {
                this.changes = true;
                return this.toastr.info("YA HA SOLICITADO LA CANTIDAD MAXIMA DE ESTE ARTICULO");
              }
            }
          });
        }
      });
    }

  }

  // Disminuye 1 la cantidad de un artículo
  disminuirCant(orderNumberBank: string, orderDetail: any){
    // Buscamos el pedido al que hay que sumarle un artículo
    let observa: Boolean = false;
    if (this.savedOrder.orderNumberBank === orderNumberBank){
      // Buscamos el detalle del pedido correspondiente con el artículo
      for (let i = 0; i < this.savedOrder.orderDetails.length; i++){
        if (orderDetail.clothes.observations !== undefined && orderDetail.clothes.observations.length !== 0){
          orderDetail.clothes.observations.forEach(observations => {
            if(observations.type==="Comentario"){
              observa = true;
            }
          });
        }else{
          observa = false;
        }
        if ((this.savedOrder.orderDetails[i].clothes.code === orderDetail.clothes.code && this.savedOrder.orderDetails[i].size === orderDetail.size &&
          (orderDetail.clothes.observations===undefined || orderDetail.clothes.observations.length===0 || !observa)) ||

          this.savedOrder.orderDetails[i].clothes.code === orderDetail.clothes.code && this.savedOrder.orderDetails[i].size === orderDetail.size &&
          orderDetail.clothes.observations.length>0 && observa && orderDetail.job.description===this.savedOrder.orderDetails[i].job.description &&
          orderDetail.ribbon.description===this.savedOrder.orderDetails[i].ribbon.description && orderDetail.weapon.description===this.savedOrder.orderDetails[i].weapon.description
          && orderDetail.generalStaff.description===this.savedOrder.orderDetails[i].generalStaff.description){

          let clothPrice = this.savedOrder.orderDetails[i].clothes.prices[this.savedOrder.orderDetails[i].clothes.prices.length - 1].price;
          if (this.savedOrder.orderDetails[i].amount > 1){
            this.savedOrder.orderDetails[i].amount -= 1;
          } else {
            this.savedOrder.orderDetails.splice(i, 1);
          }
          this.changes = true;
          return this.savedOrder.price -= clothPrice;
        }
      }
    }
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      () => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  }

  // Función para modificar pedidos
  modifyOrder(dataOrder: DataOrder){
    this.spinner.show();

    // Se pone el estado CONFIRMED por defecto
    this.savedOrder.status = "CONFIRMED";

    // Comprobamos las cantidades para poner el estado del pedido SAVED
    if (localStorage.getItem("role") !== "TIENDA FISICA"){
      this.savedOrder.orderDetails.forEach(orderDetail => {
        // En el momento que se haya solicitado más cantidad de la permitida de un artículo se pone el estado SAVED
        return orderDetail.clothes.nocSizes.forEach(nocSize => {
          if (nocSize.size === orderDetail.size){
            if (nocSize.maxAmount < orderDetail.amount){
              this.savedOrder.confirmDate = null;
              return this.savedOrder.status = "SAVED";
            }
          }
        })
      });
    }

    // Añadimos la fecha de confirmación
    this.savedOrder.confirmDate = new Date();

    if (dataOrder === undefined || dataOrder === null){
      dataOrder = {
        dataBank: null,
        domain: null,
        errorCode: null,
        id: null,
        user: null,
        nid: this.nid,
        orders: [this.savedOrder],
        receiptOrders: null,
        status: null,
        token: null,
        orderNumberBank: null,
        orderPending: null,
        pdfName: null,
        role: null,
        noc: null
      };
    }
    this.orderService.modifyOrder(dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          if (this.savedOrder.status === "SAVED"){
            this.toastr.success("SU PEDIDO HA SIDO MODIFICADO CORRECTAMENTE. DEBERA SER VALIDADO.", "PEDIDO MODIFICADO");
          } else {
            this.toastr.success("SU PEDIDO HA SIDO MODIFICADO CORRECTAMENTE", "PEDIDO MODIFICADO");
          }
          this.changes = false;
          this.getOrder();
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
        this.spinner.hide();
      }, () => {
        this.toastr.warning("SU PEDIDO NO HA SIDO MODIFICADO", "ERROR MODIFICAR PEDIDO");
        this.spinner.hide();
      }
    );
  }

  // Función para cancelar pedidos
  cancelarPedido(dataOrder: DataOrder){
    this.spinner.show();
    if (dataOrder === undefined || dataOrder === null){
      dataOrder = {
        dataBank: null,
        domain: null,
        errorCode: null,
        id: null,
        user: null,
        nid: this.nid,
        orders: [this.savedOrder],
        receiptOrders: null,
        status: null,
        token: null,
        orderNumberBank: null,
        orderPending: null,
        pdfName: null,
        role: null,
        noc: null
      };
    }
    this.orderService.cancelOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)){
          localStorage.setItem("articulos", null);
          this.orderService.sendUpdate("0");  
          this.orderService.changeTime(null);
          this.orderService.changeStatus(null);
          //this.orderService.currentArticles = new BehaviorSubject(null).asObservable();
          this.toastr.success("PEDIDO CANCELADO CORRECTAMENTE", "PEDIDO CANCELADO");
          this.spinner.hide();
          this.router.navigate(['home']);
        } else {
          this.toastr.warning(data.errorCode.message, "PEDIDO NO CANCELADO");
          this.spinner.hide();
        }
      }, () => {
        this.toastr.warning("EL PEDIDO NO SE HA CANCELADO", "PEDIDO NO CANCELADO");
        this.spinner.hide();
      }
    );
  }

  // Función que comprueba si el usuario ha introducido todos los datos pesonales
  confirmarPedido(){
    if(!this.checkInfoClothes()){
      this.toastr.info("DEBE RELLENAR OBSERVACIONES/MEDIDAS/PASADORES DE LOS ARTICULOS QUE LO REQUIERAN", "FALTAN DATOS");
      return;
    }
    if (localStorage.getItem("role") !== "TIENDA FISICA"){
      if (this.nid === null || this.nid.length === 0 || this.firstName === null || this.firstName.length === 0
          || this.lastName === null || this.lastName.length === 0 || this.phone === null || this.phone.length === 0
          || this.email === null || this.email.length === 0 || this.addresses === null || this.addresses.length === 0){
        // Si le falta algún dato se le redirecciona a la pantalla Mi Cuenta para que lo rellene
        this.toastr.info("DEBE RELLENAR TODOS LOS DATOS PERSONALES", "FALTAN DATOS");
        this.router.navigate(['my-account']);
      } else {
        // Si tiene todos los datos rellenos se muestra el modal para que elija la dirección de envío
        this.addressModal.show();
      }
    } else {
      this.spinner.show();
      this.savedOrder.status = "FINISHED";
      // Añadimos el pedido modificado a un DataOrder para modificarlo en BBDD
      let dataOrder: DataOrder = {
        dataBank: null,
        domain: null,
        errorCode: null,
        id: null,
        nid: localStorage.getItem("nid"),
        orders: [],
        receiptOrders: null,
        status: null,
        token: null,
        orderNumberBank: null,
        orderPending: null,
        user: null,
        pdfName: null,
        role: null,
        noc: null
      };
      dataOrder.orders.push(this.savedOrder);

      this.orderService.modifyOrder(dataOrder).subscribe(
        data => {
          if (getToken(data)){
            data.errorCode = null;
            data.token = null;
            this.orderService.separateOrders(data).subscribe(
              data => {
                if (getToken(data)){
                  this.separatedOrders = data.orders;
                  this.checkPayment();
                } else {
                  this.toastr.warning(data.errorCode.message, "ERROR");
                }
              }, () => {
                this.toastr.error("SE HA PRODUCIDO UN ERROR AL CONFIRMAR EL PEDIDO", "ERROR");
              }
            );
          } else {
            this.toastr.warning(data.errorCode.message, "ERROR");
          }
        }, () => {
          this.toastr.error("SE HA PRODUCIDO UN ERROR AL CONFIRMAR EL PEDIDO", "ERROR");
        }
      );
    }

  }

  separateOrders(){
    this.spinner.show();
    // Añadimos la dirección seleccionada al pedido
    for (let i = 0; i < this.addresses.length; i++) {
      if (this.addresses[i].id.toString() === this.selectAddress.toString()){
        this.savedOrder.address = this.addresses[i];
        break;
      }

    }


    let dataOrder: DataOrder = {
      dataBank: null,
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: this.nid,
      orders: [this.savedOrder],
      receiptOrders: null,
      status: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null
    };
    // Desdoblamos el pedido por familia antes de realizar el pago
    this.orderService.separateOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)){
          this.separatedOrders = data.orders;
          this.addressModal.hide();
          this.dataBank();
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
        this.spinner.hide();
      }, () => {
        this.toastr.error("NO SE HA PODIDO CONFIRMAR EL PEDIDO", "ERROR");
        this.spinner.hide();
      }
    );
  }

  dataBank() {
    this.spinner.show();
    let dataOrder: DataOrder = new DataOrder();
    this.order.orderNumberBank = this.savedOrder.orderNumberBank;
    this.order.price = this.savedOrder.price;

    dataOrder.orders = [this.order];
    this.orderService.postBank(dataOrder).subscribe(
      data => {
        if (getToken(data)) {
          this.version = data.dataBank.ds_SignatureVersion;
          this.parameters = data.dataBank.ds_MerchantParameters;
          this.signature = data.dataBank.ds_Signature;
          this.confirmModal.show();
        }
    },
      () => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS DATOS", "ERROR");
      }
    )

    this.spinner.hide();
  }

  submitData(){
    const link = document.getElementById("btnBank");
    link.click();
    this.checkPayment();
  }

  // Comprobamos si se ha finalizado el pago cada 60s
  checkPayment(){
    this.spinner.show();
    let orderService = this.orderService;
    let savedOrder = this.savedOrder;
    let printModal = this.printModal;
    let spinner = this.spinner;
    let confirmModal = this.confirmModal;
    let timerId = setInterval(function checkOrders(){
      orderService.getFinishedOrders(savedOrder.orderNumberBank).subscribe(
        data => {
          if (getToken(data)){
            if (data.orders !== undefined && data.orders !== null && data.orders.length > 0){
              confirmModal.hide();
              printModal.show();
              spinner.hide();
              clearInterval(timerId);
            }
          }
        }
      );
    }, 60000);
  }

  unifyOrders(){
    this.spinner.show();
    let dataOrder: DataOrder = {
      dataBank: null,
      domain: null,
      errorCode: null,
      id: null,
      user: null,
      nid: this.nid,
      orders: this.separatedOrders,
      receiptOrders: null,
      status: null,
      token: null,
      orderNumberBank: null,
      orderPending: null,
      pdfName: null,
      role: null,
      noc: null
    };
    this.orderService.unifyOrders(dataOrder).subscribe(
      data => {
        if (getToken(data)){
          this.separatedOrders = [];
          this.confirmModal.hide();
          this.getOrder();
        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
        }
      }, () => {
        this.toastr.error("SE HA PRODUCIDO UN ERROR", "ERROR");
      }
    );

  }

  //Genera el justificante del pedido
  print(){
    let data: DataOrder = new DataOrder();
    data.nid = localStorage.getItem("nid");
    data.orders = this.separatedOrders;
    data.role = localStorage.getItem("role");
    this.orderService.getReceiptOrders(data).subscribe(
      data => {
        if (getToken(data)) {
          if(data.receiptOrders!=null){
            const source = 'data:application/pdf;base64,'+data.receiptOrders;
            const link = document.createElement("a");
            link.href = source;
            link.download = 'justificante.pdf';
            link.click();
            this.closePrintModal();
          }else{
            this.toastr.info("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "INFO");
            this.spinner.hide();
            this.router.navigate(['home']);
          }

        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.router.navigate(['login']);
        }
      },
      () => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL GENERAR EL JUSTIFICANTE", "ERROR");
      }
    )
  }

  closePrintModal(){
    this.printModal.hide();
    this.orderService.sendUpdate("0");  
    this.orderService.changeTime(null);
    this.orderService.changeStatus(null);
    this.router.navigate(['home']);
  }
  
  checkBloqueado() {
    let fecha = new Date();
    this.blockService.getBlockApp().subscribe(
      data => {
        if (fecha <= data.endDate && fecha >= data.initialDate) {
          this.description = data.description;
          this.startDate = data.initialDate;
          this.endDate = data.endDate;
          this.bloqueado = true;
          this.spinner.hide();
        } else {
          this.getOrder();
        }
      });
  }

  openObservation(orderNumberBank: string, index: number){
    this.indexClothes = index;
    this.jobData = this.savedOrder.orderDetails[index].job.description;
    this.ribbonData = this.savedOrder.orderDetails[index].ribbon.description;
    this.generalStaffData = this.savedOrder.orderDetails[index].generalStaff.description;
    this.weaponData = this.savedOrder.orderDetails[index].weapon.description;
    this.observationData = this.savedOrder.orderDetails[index].observation;
    this.observationModal.show();
  }
  
  openMeasures(orderNumberBank: string, index: number){
    this.indexClothes = index;
    this.myAltura = this.savedOrder.orderDetails[index].height;
    this.myCintura= this.savedOrder.orderDetails[index].waist;
    this.myTorax = this.savedOrder.orderDetails[index].thorax;
    this.measuresModal.show();
  }

  openPin(orderNumberBank: string, index: number){
    this.indexClothes = index;
    this.myPinsObservation = this.savedOrder.orderDetails[index].pinObservation;
    this.selectPin();
    this.pinModal.show();
  }

  selectPin(){
    let ok: boolean = false;
    let index: number = 0;
    let idSelect: number =this.savedOrder.orderDetails[this.indexClothes].pinGroup === null ? 0 :  this.savedOrder.orderDetails[this.indexClothes].pinGroup.id
    this.pinesGroup.forEach(detail =>{
      if(idSelect === detail.id){
        ok = true;
      }else{
        if(!ok) index++; 
      }
       
    });
    this.activeSlideIndex = ok ? index : 0;
  }

  infoObservation(clothe: Clothes){
    let result: boolean=false;
    clothe.observations.forEach(obs => {
      if(obs.type==='Comentario'){
        result = true;
      }
    });
    return result;
  }

  infoMeasures(clothe: Clothes){
    let result: boolean = false;
    clothe.observations.forEach(obs => {
      if(obs.type==='Talla'){
        result = true;
      }
    });
    return result;
  }

  infoPin(clothe: Clothes){
    let result: boolean = false;
    clothe.observations.forEach(obs => {
      if(obs.type==='Pasadores'){
        result = true;
      }
    });
    return result;
  }
  
  aceptObservation(){
    this.changes = true;
    this.savedOrder.orderDetails[this.indexClothes].observation= (<HTMLInputElement>document.getElementById("observation")).value;
    this.toastr.info("RECUERDE PULSAR MODIFICAR PARA GUARDAR LOS CAMBIOS","INFO");
    this.observationModal.hide();
  }

  aceptMeasures(){
    this.myAltura = (<HTMLInputElement>document.getElementById("alturaArea")).value;
    this.myCintura= (<HTMLInputElement>document.getElementById("cinturaArea")).value;
    this.myTorax = (<HTMLInputElement>document.getElementById("toraxArea")).value;
    this.savedOrder.orderDetails[this.indexClothes].height = this.myAltura;
    this.savedOrder.orderDetails[this.indexClothes].thorax = this.myTorax;
    this.savedOrder.orderDetails[this.indexClothes].waist =this.myCintura;
    this.toastr.info("RECUERDE PULSAR MODIFICAR PARA GUARDAR LOS CAMBIOS","INFO");
    this.measuresModal.hide();
  }

  aceptPins(){
    if(this.activeSlideIndex.relatedTarget!==undefined){
      this.savedOrder.orderDetails[this.indexClothes].pinGroup = this.pinesGroup[this.activeSlideIndex.relatedTarget];
    }else{
      this.savedOrder.orderDetails[this.indexClothes].pinGroup = this.pinesGroup[0];
    }
    this.myPinsObservation = (<HTMLInputElement>document.getElementById("myPinsObservation")).value;
    this.savedOrder.orderDetails[this.indexClothes].pinObservation = this.myPinsObservation;
    this.toastr.info("RECUERDE PULSAR MODIFICAR PARA GUARDAR LOS CAMBIOS","INFO");
    this.pinModal.hide();
  }

  checkInfoClothes(){
    let obser : boolean = true;
    this.savedOrder.orderDetails.forEach(detail =>{
      if(detail.clothes.observations.length>0){
        detail.clothes.observations.forEach(obs => {
          if(obs.type==='Talla'){
            if(detail.waist===null || detail.height===null || detail.thorax===null || detail.waist.length<=0 || detail.height.length<=0 || detail.thorax.length<=0){
              obser = false;
            }
          }
          if(obs.type==='Comentario'){
            if(detail.generalStaff.description.length<=0 || detail.job.description.length<=0 || detail.ribbon.description.length<=0 ||
              detail.weapon.description.length<=0 || detail.observation===null || detail.observation.length<=0){
                obser = false;
            }
          }
          if(obs.type==='Pasadores'){
            if(detail.pinGroup===null){
                obser = false;
            }
          }
        });
      }
    });
    return obser;
  }

  getPinGroup() {
    let nid = localStorage.getItem("nid");

    //Se solicitan todos los pedidos del usuario que se encuentren finalizados
    this.pinService.getPinsByUser(nid).subscribe(
      data => {
        if (getToken(data)) {
          if (data.pinGroups != null) {
            this.pinesGroup = data.pinGroups;
            this.spinner.hide();
          }

        } else {
          this.toastr.warning(data.errorCode.message, "ERROR");
          localStorage.clear();
          this.router.navigate(['login']);
        }
      },
      error => {
        this.spinner.hide();
        this.toastr.error("HA OCURRIDO UN ERROR AL CARGAR LOS PASADORES", "ERROR");
      }
    )
  }

}
